package api.dataclasses.outbound

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class OutboundOrder (
    @SerialName("RecordId") val recordId: Int,
    @SerialName("Eigenaar") val owner: String,
    @SerialName("Referentie") val reference: String,
    @SerialName("Orderdatum") val orderDate: String,
    @SerialName("Statusomschrijving") val statusDescription: String,
    @SerialName("Te_picken_aantal") val amountToPick: Double,
    @SerialName("Naam") val name: String,
    @SerialName("Adres") val address: String,
    @SerialName("Postcode") val zipCode: String,
    @SerialName("Plaats") val city: String,
    @SerialName("Land") val country: String
)
